import { ajax } from "../services/ajax";
import { api } from "../constants";

export const getUpdatesList = () => {
  return ajax.get(api.endpoints.app.forcUpdate.list)
}
export const addForceUpdate = options => {
  return ajax.post(api.endpoints.app.forcUpdate.update, options)
}
